import React from 'react'

import css from './style.css'
export default ({ heading, size, className, children, bold, italic, ...props }) => {
    let classes = []

    if(size) classes.push(css[`display${size}`])
    if(bold) classes.push(css.bold)
    if(italic) classes.push(css.italic)
    if(className) classes.push(className)

    if(heading) {
        if(size === 1) return <h1 className={classes.join(' ')} {...props}>{children}</h1>
        if(size === 2) return <h2 className={classes.join(' ')} {...props}>{children}</h2>
        if(size === 3) return <h3 className={classes.join(' ')} {...props}>{children}</h3>
    }

    return <span
                className={classes.join(' ')}
                {...props}
            >{children}</span>
}


// WEBPACK FOOTER //
// ./src/v2SPRINTA/atoms/Display/index.js